import dispatchAxiosUpdatedEvent from './axios-updated-event';

let numberOfRequests = 1;

function handleRequest(request, tag = 'AXIOS') {
	const currentRequestNumber = numberOfRequests;
	const currentRequestNumberPadded = currentRequestNumber.toString().padStart(3, 0);
	const labelColor = '#ff9900';
	const tagTextColor = tag === 'AXIOS' ? 'white' : 'red';
	const requestMethod = request.method?.toUpperCase();

	let requestURLShort = '';

	if (request.url.startsWith('/api/user/')) {
		requestURLShort = '/api/user/{id}';
	} else {
		requestURLShort = request.url;
	}

	let label = requestURLShort;
	let fileName = '';
	let mimeType = '';

	if (typeof request?.data?.has === 'function' && request?.data?.has('file')) {
		const files = request?.data?.getAll('file');
		fileName = files[0].name;
		mimeType = files[0].type;
	}

	if (mimeType) label += ' (' + mimeType + ')';

	request.number = currentRequestNumber;

	window.debug.axios.requests[currentRequestNumber] = {
		method: requestMethod,
		url: request.url,
		success: false,
		size: 0,
		route: window.location.hash.replace('#', ''),
		number: currentRequestNumber,
		fileName: fileName,
		mimeType: mimeType
	};

	console.groupCollapsed(
		`%c[${tag}#${currentRequestNumberPadded}] ${requestMethod}%c${label.replace(/\?.*/, '')}%c`,
		`background:#35495e ; padding: 3px 9px 3px 4px; border-radius: 3px 0 0 3px;  color: ${tagTextColor}`,
		`background:${labelColor} ; padding: 3px 6px 3px 6px; border-radius: 0 3px 3px 0;  color: #fff`,
		'background:transparent'
	);
	console.warn(`[${tag}#${currentRequestNumberPadded}] Request: ${request.url}`);
	console.log('REQUEST', request);
	console.groupEnd();

	dispatchAxiosUpdatedEvent();

	numberOfRequests++;

	return currentRequestNumber;
}

export default handleRequest;
